/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VitalSignPainScaleFieldAliases {
  CONTEXTUAL_BAR_PAIN_SCALE = 'contextual-bar-pain-scale',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  PAIN_SCALE_FIELD_LAYOUT = 'pain-scale-field-layout',
  PAIN_SCALE_FIELD_PANEL_MODAL = 'pain-scale-field-panel-modal',
  PAIN_SCALE_FIELD_REFERENCE_PANEL = 'pain-scale-field-reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
  VITAL_SIGN_PAIN_SCALE_FIELD_PANEL = 'vital-sign-pain-scale-field-panel',
  VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_FORM = 'vital-sign-pain-scale-field-radio-form',
  VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_GROUP = 'vital-sign-pain-scale-field-radio-group',
  VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_GROUP_FIELD = 'vital-sign-pain-scale-field-radio-group-field',
  VITAL_SIGN_PAIN_SCALE_FIELD_REFERENCE_LINK = 'vital-sign-pain-scale-field-reference-link',
}
export { VitalSignPainScaleFieldAliases };
